import React from 'react';
import PropTypes from 'prop-types';

import { TableCell, TableRow } from '@mui/material';

import OnEditIcon from '../../../../icons/OnEditIcon';
import OnFileDownloadIcon from '../../../../icons/OnFileDownloadIcon';
import { reverseFormatDate } from '../../../../utils/dateFunctions';

import classes from '../../../../commonStyles/tables.module.css';

const FinancialRequestRow = ({ row, onEdit, onDownload, isDisabled }) => {
    return (
        <TableRow hover className={`${classes.basicRowStripes}`}>
            <TableCell>{row.code}</TableCell>
            <TableCell>{row.type}</TableCell>
            <TableCell>{row.amount}</TableCell>
            <TableCell>{row.status}</TableCell>
            <TableCell>{reverseFormatDate(row.statusChangeDate) || '-'}</TableCell>
            <TableCell>{reverseFormatDate(row.dateIssued) || '-'}</TableCell>
            <TableCell>{row.user || '-'}</TableCell>
            <TableCell align="right">
                <OnFileDownloadIcon
                    onDownload={() => onDownload(row)}
                    active={!isDisabled && !!onDownload}
                />
            </TableCell>
            <TableCell align="right">
                <OnEditIcon onEdit={(e) => onEdit(e, row)} active={!isDisabled} />
            </TableCell>
        </TableRow>
    );
};

FinancialRequestRow.propTypes = {
    row: PropTypes.object,
    onEdit: PropTypes.func,
    onDownload: PropTypes.func,
    isDisabled: PropTypes.bool
};

export default FinancialRequestRow;
